import React from 'react'
import ColorTag from 'components/ColorTag'
import style from '../DataTable.module.scss'
import get from 'lodash/get'

const CellColorTag = (defaultTagColor, cellRenderer) => (row) => {
	return(
		<>
			<ColorTag className={style.cellColorTag} color={get(row, 'original.color', get(row, 'original.category.color', defaultTagColor))} />
			{cellRenderer ? cellRenderer(row) : row.value}
		</>
	)
}
export default CellColorTag
